import axios from "axios";
import { API } from "../Constants/APIs";

export const MAP_SCAN_AUTH_TOKEN_KEY = "actuality_map_scan_token";
export const SCANNED_MARKERS_KEY = "actuality_scanned_location_markers";
export const LISTENED_AUDIO_MARKERS_KEY = "actuality_listened_audio_markers";
export const LOCATION_MAP_REDIRECT_TOAST_KEY =
  "actuality_location_map_redirect_toast";
export const AR_MARKER_UNLOCK_SEQUENCE = [
  "ar-1",
  "ar-2",
  "ar-3",
  "ar-4",
  "ar-5",
];

const MAP_BOUNDS = {
  east: -79.87572,
  north: 43.291294,
  south: 43.290554,
  west: -79.87712,
};

function percentToPosition(x, y) {
  return {
    lat: MAP_BOUNDS.north - ((MAP_BOUNDS.north - MAP_BOUNDS.south) * y) / 100,
    lng: MAP_BOUNDS.west + ((MAP_BOUNDS.east - MAP_BOUNDS.west) * x) / 100,
  };
}

export const LOCATION_CONFIG = {
  title: "Actuality QR Trail",
  subtitle:
    "Explore the full Anchorball scavenger hunt trail, open sculpture audio guides, and scan AR QR points.",
  center: { lat: 43.29172, lng: -79.87545 },
  zoom: 16,
  markers: [
    {
      id: "tulip-1",
      title: "Tulip Dancer",
      description:
        "One of four crimson Tulips standing sentinel over the formal beds — petals frozen at the exact moment of bloom.",
      audioSrc: "/audio/anchorball/tulip-dancers.mp3",
      imageSrc: "/qr/characters/Tulips.png",
      describe: "Tulip Dancers grew up moving together. Their synchronized motion keeps time from tearing.",
      category: "green",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 1,
      position: { lat: 43.291959, lng: -79.87447 },
    },
    {
      id: "tulip-2",
      title: "Tulip Dancer",
      description:
        "A sister bloom in the Tulip quartet, leaning toward the morning light like it never stopped growing.",
      audioSrc: "/audio/anchorball/tulip-dancers.mp3",
      imageSrc: "/qr/characters/Tulips.png",
      describe: "Tulip Dancers grew up moving together. Their synchronized motion keeps time from tearing.",
      category: "green",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 2,
      position: { lat: 43.291972, lng: -79.874335 },
    },
    {
      id: "tulip-3",
      title: "Tulip Dancer",
      description:
        "The third Tulip, its stem twisting in a slow spiral that catches shadows across the path.",
      audioSrc: "/audio/anchorball/tulip-dancers.mp3",
      imageSrc: "/qr/characters/Tulips.png",
      describe: "Tulip Dancers grew up moving together. Their synchronized motion keeps time from tearing.",
      category: "green",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 3,
      position: { lat: 43.291816, lng: -79.874472 },
    },
    {
      id: "tulip-4",
      title: "Tulip Dancer",
      description:
        "The final Tulip closes the formal-garden quartet — look for the hidden bud near its base.",
      audioSrc: "/audio/anchorball/tulip-dancers.mp3",
      imageSrc: "/qr/characters/Tulips.png",
      describe: "Tulip Dancers grew up moving together. Their synchronized motion keeps time from tearing.",
      category: "green",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 4,
      position: { lat: 43.291861, lng: -79.874294 },
    },
    {
      id: "willy",
      title: "Willy",
      description:
        "A wide-eyed wanderer planted at the south gate, greeting every explorer who enters the trail.",
      audioSrc: "/audio/anchorball/willy.mp3",
      imageSrc: "/qr/characters/Willy.png",
      describe: "Willy stands where movement begins. In a city that floats, he anchors.",
      category: "green",
      markerType: "sculpture",
       modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Character Sculpture",
      number: 16,
      position: { lat: 43.290987, lng: -79.875892 },
    },
    {
      id: "hue-shine",
      title: "Hue Shine",
      description:
        "A prism made solid — its surfaces throw a different colour onto the lawn with every passing hour.",
      audioSrc: "/audio/anchorball/hue-shine.mp3",
      imageSrc: "/qr/characters/HueShine.png",
      describe: "Hue Shine grew up reflecting truth. Color sharpens identity without judgment or commentary.",
      category: "red",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 6,
      position: { lat: 43.29206, lng: -79.876333 },
    },
    {
      id: "king-pao",
      title: "Kung Pao",
      description:
        "Bold, blocky and grinning, Kung Pao rules the central crossing of the gardens with quiet mischief.",
      audioSrc: "/audio/anchorball/king-pao.mp3",
      imageSrc: "/qr/characters/KungPao.png",
      describe: "Kung Pao grew up as friction. He brings heat not to destroy, but to strengthen",
      category: "red",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 7,
      position: { lat: 43.291715, lng: -79.875861 },
    },
    {
      id: "mystiflora",
      title: "Mystiflora",
      description:
        "Half flower, half riddle. Mystiflora hides a tiny face in its petals — find it and make a wish.",
      audioSrc: "/audio/anchorball/mystiflora.mp3",
      imageSrc: "/qr/characters/Mystiflora.png",
      describe: "Mystiflora grew up keeping secrets. She reminds the city that not everything needs to be known.",
      category: "red",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 8,
      position: { lat: 43.292162, lng: -79.875445 },
    },
    {
      id: "petal-nova",
      title: "Petal Nova",
      description:
        "An explosion caught mid-burst, Petal Nova scatters colour the way a firework scatters light.",
      audioSrc: "/audio/anchorball/petal-nova.mp3",
      imageSrc: "/qr/characters/PetalNova.png",
      describe: "Petal Nova exploded into form. Creation around her arrives all at once, reshaping everything it touches.",
      category: "red",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 9,
      position: { lat: 43.291869, lng: -79.875211 },
    },
    {
      id: "bubblegum-girl",
      title: "Bubblegum Girl",
      description:
        "Camouflaged in nature and blowing a bubble that never pops — the centrepiece of A Curious Art Journey.",
      audioSrc: "/audio/anchorball/bubblegum-girl.mp3",
      imageSrc: "/qr/characters/BubblegumGirl.png",
      describe: "Bubblegum Girl keeps it elastic. She moves through the streets like a pop song leaking from headphones.",
      category: "red",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Venus Sculpture",
      number: 10,
      position: { lat: 43.292183, lng: -79.874487 },
    },
    {
      id: "verdant-oracle",
      title: "Verdant Oracle",
      description:
        "A leaf-cloaked seer at the garden’s edge, said to whisper next season’s blooms to those who listen.",
      audioSrc: "/audio/anchorball/verdant-oracle.mp3",
      imageSrc: "/qr/characters/VerdantOracle.png",
      describe: "The Verdant Oracle lives where decisions haven’t happened yet.",
      category: "red",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Venus Sculpture",
      number: 11,
      position: { lat: 43.291483, lng: -79.877169 },
    },
    {
      id: "spire-blossom",
      title: "Spire Blossom",
      description:
        "Reaching skyward in a single elegant spire, this blossom is best viewed from directly below.",
      audioSrc: "/audio/anchorball/spire-blossom.mp3",
      imageSrc: "/qr/characters/SpireBlossom.png",
      describe: "Spire Blossom grew upward because listening sideways wasn’t enough.",
      category: "blue",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Floral Sculpture",
      number: 12,
      position: { lat: 43.291771, lng: -79.876482 },
    },
    {
      id: "first-light",
      title: "First Light",
      description:
        "Catches the very first sun of the day — arrive early and watch it glow from the inside out.",
      audioSrc: "/audio/anchorball/first-light.mp3",
      imageSrc: "/qr/characters/FirstLight.png",
      describe: "First Light lives in the edges of time—dawn, dusk, moments before clarity hits",
      category: "blue",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Venus Sculpture",
      number: 13,
      position: { lat: 43.291529, lng: -79.876289 },
    },
    {
      id: "quantum-leap",
      title: "Quantum Leap",
      description:
        "A playful jolt of energy mid-jump, suspended forever between one idea and the next.",
      audioSrc: "/audio/anchorball/quantum-leap.mp3",
      imageSrc: "/qr/characters/quantumLeap.png",
      describe: "Quantum Leap appears when patience fails. He is not chaos—he’s compression",
      category: "blue",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Character Sculpture",
      number: 14,
      position: { lat: 43.292193, lng: -79.873703 },
    },
    {
      id: "bloom-ascendant",
      title: "Bloom Ascendant",
      description:
        "A flower rising through its own petals — a quiet study of growth that never finishes.",
      audioSrc: "/audio/anchorball/bloom-ascendant.mp3",
      imageSrc: "/qr/characters/BloomAscendant.png",
      describe: "Bloom Ascendant is the city’s upward pressure. She reminds the city that gravity is negotiable.",
      category: "blue",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Venus Sculpture",
      number: 15,
      position: { lat: 43.291522, lng: -79.874937 },
    },
    {
      id: "winky",
      title: "Winky",
      description:
        "The camo-suited explorer of the journey, frozen mid-wave to send you off to the next find.",
      audioSrc: "/audio/anchorball/winky.mp3",
      imageSrc: "/qr/characters/Winky.png",
      describe: "Winky watches what people don’t say. She reads emotional frequencies the way others read signs.",
      category: "blue",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Character Sculpture",
      number: 5,
      position: { lat: 43.290983, lng: -79.875635 },
    },
    {
      id: "bunni-b",
      title: "Bunni B",
      description:
        "Mapped in red and blue, Bunni B bounds along the north ridge as the trail’s cheerful guide.",
      audioSrc: "/audio/anchorball/bunni-b.mp3",
      imageSrc: "/qr/characters/BunniB.png",
      describe: "Bunni B moves faster than intention. He hops between sceneand ideas, leaving  behind sparks",
      category: "blue",
      markerType: "sculpture",
      modalProductId: "64ae605390b5f36c673afebb",
      sculpture_type: "Character Sculpture",
      number: 17,
      position: { lat: 43.292892, lng: -79.876788 },
    },
    {
      id: "ar-1",
      title: "Augmented Reality",
      description: "Scan this QR point to open the AR experience.",
      category: "purple",
      markerType: "qr",
      modalProductId: "6a21164647dec9d612ec1f4c",
      qrLabel: "AR",
      position: { lat: 43.292053, lng: -79.875221 },
    },
    {
      id: "ar-2",
      title: "Augmented Reality",
      description: "Scan this QR point to open the AR experience.",
      category: "purple",
      markerType: "qr",
      modalProductId: "6a1ce643f0064ce2245e8e9d",
      qrLabel: "AR",
      position: { lat: 43.292685, lng: -79.87652 },
    },
    {
      id: "ar-3",
      title: "Augmented Reality",
      description: "Scan this QR point to open the AR experience.",
      category: "purple",
      markerType: "qr",
      modalProductId: "699473d57e82616392d88765",
      qrLabel: "AR",
      position: { lat: 43.291959, lng: -79.87653 },
    },
    {
      id: "ar-4",
      title: "Augmented Reality",
      description: "Scan this QR point to open the AR experience.",
      category: "purple",
      markerType: "qr",
      modalProductId: "6a21199c47dec9d612ec22f4",
      qrLabel: "AR",
      position: { lat: 43.291721, lng: -79.877212 },
    },
    {
      id: "ar-5",
      title: "Augmented Reality",
      description: "Scan this QR point to open the AR experience.",
      category: "purple",
      markerType: "qr",
      modalProductId: "6a211a4647dec9d612ec2444",
      qrLabel: "AR",
      position: { lat: 43.291436, lng: -79.874524 },
    },
    {
      id: "ar-6",
      title: "Augmented Reality",
      description: "Unlocked after all five AR markers are scanned.",
      category: "purple",
      markerType: "qr",
      modalProductId: "6a21182247dec9d612ec21af",
      qrLabel: "AR",
      hiddenUntilMarkersScanned: AR_MARKER_UNLOCK_SEQUENCE,
      position: { lat: 43.292036, lng: -79.874790 },
    },
  ],
};

export function getMapScanToken() {
  return localStorage.getItem(MAP_SCAN_AUTH_TOKEN_KEY) || "";
}

export function setMapScanToken(token) {
  localStorage.setItem(MAP_SCAN_AUTH_TOKEN_KEY, token);
}

export function clearMapScanToken() {
  localStorage.removeItem(MAP_SCAN_AUTH_TOKEN_KEY);
}

export function readScannedMarkers() {
  try {
    const storedValue = localStorage.getItem(SCANNED_MARKERS_KEY);
    return storedValue ? JSON.parse(storedValue) : [];
  } catch (error) {
    return [];
  }
}

export function writeScannedMarkers(markerIds) {
  localStorage.setItem(SCANNED_MARKERS_KEY, JSON.stringify(markerIds));
}

export function readListenedAudioMarkers() {
  try {
    const storedValue = localStorage.getItem(LISTENED_AUDIO_MARKERS_KEY);
    return storedValue ? JSON.parse(storedValue) : [];
  } catch (error) {
    return [];
  }
}

export function writeListenedAudioMarkers(markerIds) {
  localStorage.setItem(LISTENED_AUDIO_MARKERS_KEY, JSON.stringify(markerIds));
}

export function markAudioMarkerAsListened(markerId) {
  if (!markerId) {
    return readListenedAudioMarkers();
  }

  const currentMarkers = readListenedAudioMarkers();

  if (currentMarkers.includes(markerId)) {
    return currentMarkers;
  }

  const updatedMarkers = [...currentMarkers, markerId];
  writeListenedAudioMarkers(updatedMarkers);
  return updatedMarkers;
}

export function markMarkerAsScanned(markerId) {
  if (!markerId) {
    return readScannedMarkers();
  }

  const currentMarkers = readScannedMarkers();

  if (currentMarkers.includes(markerId)) {
    return currentMarkers;
  }

  const updatedMarkers = [...currentMarkers, markerId];
  writeScannedMarkers(updatedMarkers);
  return updatedMarkers;
}

export function getMarkerIdsFromScans(scans = []) {
  return [...new Set(scans.map((scan) => scan?.marker_id).filter(Boolean))];
}

export function getListenedAudioMarkerIdsFromScans(scans = []) {
  return [
    ...new Set(
      scans
        .filter((scan) => scan?.audio_listened)
        .map((scan) => scan?.marker_id)
        .filter(Boolean)
    ),
  ];
}

export function getMarkerById(markerId) {
  return LOCATION_CONFIG.markers.find((marker) => marker.id === markerId) || null;
}

export function getVisibleLocationMarkers(scannedMarkerIds = []) {
  return LOCATION_CONFIG.markers.filter((marker) => {
    const requiredMarkers = marker.hiddenUntilMarkersScanned || [];
    return requiredMarkers.every((markerId) => scannedMarkerIds.includes(markerId));
  });
}

export function getMarkerByModalProductId(productId) {
  return (
    LOCATION_CONFIG.markers.find((marker) => marker.modalProductId === productId) ||
    null
  );
}

export async function authenticateMapScanUser(payload) {
  const response = await axios.post(API.postUrls.mapScanAuth, payload);
  return response.data;
}

export async function getCurrentMapScanUser(token) {
  const response = await axios.get(API.getUrls.mapScanUser, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function saveMapScanModal({
  audioListened,
  modelId,
  scannedTime,
  token,
  markerId,
  markerTitle,
  markerLat,
  markerLng,
}) {
  const response = await axios.post(
    API.postUrls.mapScanModal,
    {
      model_id: modelId,
      scanned_time: scannedTime,
      marker_id: markerId,
      marker_title: markerTitle,
      marker_lat: markerLat,
      marker_lng: markerLng,
      audio_listened: Boolean(audioListened),
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
}

export async function getMapScanModals(token) {
  const response = await axios.get(API.getUrls.mapScanModals, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

export async function clearMapScanModals(token) {
  const response = await axios.delete(API.deleteUrls.mapScanModals, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}
